<template>
  <div class='mb25 s_flex_ali'>
    <span class='mr15'>
      <a-button type="primary" @click="create">
        <PlusOutlined />
        添加类型
      </a-button>
    </span>
  </div>
  <p class="m-b-15">系统分类不支持删除，只能修改名称；自定义的分类仅做展示，不做逻辑区分</p>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='type_id' :columns='columns' :data-source='data'>
    <template v-slot:action="{ record }">
      <a-button type="primary" size="small" @click="editType(record)">修改</a-button>
      <a-button type="primary" v-if="record.is_default==0" danger size="small" v-has:storeLevelTypeDel="()=>delType(record)"  class="m-l-10">删除</a-button>
    </template>
     <template v-slot:is_default="{ record }">
        <p v-if="record.is_default==0">用户创建</p>
        <p v-if="record.is_default==1">系统数据</p>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />

  <a-modal  :keyboard="false"
    :title="type=='edit'?'编辑类型':'添加类型'"
    :width='500'
    centered
    :footer="null"
    v-model:visible="visible"
    @ok="handleOk"
    destroyOnClose
  >
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item ref="name" label="类型名称" name="name">
        <a-input v-model:value="form.name" placeholder='请输入类型名称' />
      </a-form-item>
      <a-form-item ref="is_default" label="类型来源" name="is_default">
        <p v-if="form.is_default==0">用户创建</p>
        <p v-if="form.is_default==1">系统数据</p>
      </a-form-item>
      <a-form-item ref="remarks" label="备注" name="remarks">
        <a-textarea v-model:value="form.remarks" showCount :maxlength="100" placeholder="请输入备注" :rows="4" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 4, offset: 4 }">
        <a-button v-if="type=='add'" type="primary" v-has:storeLevelTypeCreate="onSubmit" >
          保存
        </a-button>
          <a-button v-else type="primary" v-has:storeLevelTypeEdit="onSubmit" >
          保存
        </a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getTypeList,TypeAdd,typeEdit,typeDel } from "@/api/store";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defForm = {
    name: '',
    remarks:''
  }
  let defSearch = {
    page: 1,
    limit: 10
  };
  export default {
    components: {  },
    name:'typeList',
    setup(props, ctx) {
      // 列表数据和列头配置
      let data = ref([]);
      const form = ref({ ...defForm });
      const search = ref({ ...defSearch });
      const state = reactive({
        visible:false,
        listLoading: false,
        type:'add',
        total: 1,
        edit:false,
        labelCol: { span:4 },
        wrapperCol: { span: 16 },
        rules: {
          name: [
            { required: true, message: '请输入类型名称', trigger: 'blur' }
          ],
        }
      });
      let columns = [
        {
          title: "类型编号",
          dataIndex: "type_id",
          key: "type_id",
        },
        {
          title: "类型名称",
          dataIndex: "type_name",
          key: "type_name",
        },
           {
          title: "类型来源",
          dataIndex: "is_default",
          key: "is_default",
          slots: { customRender: "is_default" },

        },
        {
          title: "备注",
          dataIndex: "type_remarks",
          key: "type_remarks",
          customRender: ({ text,record }) => {
            return record.type_remarks ?record.type_remarks:'-'
          }
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //删除类型
      const delType = (e) => {
        $Modal.confirm({
          centered:true,
          title:'删除门店类型',
          content: '删除后该类型将无法恢复，您确定要删除该门店类型吗？', onOk:async () => {
            let res = await typeDel({id:e.type_id}).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            }else {
              message.error(res.msg);
            }
          }
        })
      }
      // 修改
      const editType = (e) =>{
        form.value.name = e.type_name
        form.value.remarks = e.type_remarks
        form.value.id = e.type_id
        form.value.is_default = e.is_default
        state.visible = true
        state.type = 'edit'
      }
      const ruleForm = ref()
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          let res
          const hide = message.loading('正在加载中...', 0);
          if(state.type == 'add'){
            res = await TypeAdd(form.value).then(res => res.data);
          }else{
            res = await typeEdit(form.value).then(res => res.data);
          }
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            setTimeout(() => {
              state.visible = false
              initData(search.value)
              state.type = 'add'
            }, 1000);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getTypeList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      const create=()=>{
        state.visible = true
         form.value={
            name: '',
            remarks:'',
            is_default:0,
          }
      }

      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        form,
        data,
        columns,
        pageCurrentChange,
        pageSizeChange,
        delType,
        editType,
        ruleForm,
        onSubmit,
        create
      };
    },
  };
</script>